import React from 'react';
import type { PrinterMachineTasksData } from '../../../common/types/printerTask.type';
import { formatDateTime } from '../../../common/utils/formatters';
import PrinterTaskFailureReason from '../components/PrinterTaskFailureReason';
import { printerMachinesTasksStrategy } from '../constants/printerMachinesTasksStatus.constant';

export class PrinterTasksTransformer {
  static tableTransformer() {
    return (printerTasks: PrinterMachineTasksData[]) => {
      return printerTasks.map((task) => ({
        id: task.id,
        status: printerMachinesTasksStrategy[task.status as keyof typeof printerMachinesTasksStrategy],
        failure_reason: task.failure_reason
        ? React.createElement(PrinterTaskFailureReason, { failure_reason: task.failure_reason })
        : '',      
        created_at: formatDateTime(new Date(task?.created_at || 0)),
      }));
    };
  }
}